import React, { useEffect } from "react";
import { Modal, Header, Icon } from "semantic-ui-react";
import WithEventWarning from "../WithEventWarning/WithEventWarning";
import SharedFunctions from "../../utils/SharedFunctions";

import { FINALIZE_EMPTY_AFRAMEMIXED_MODAL } from "../../utils/constants/componentConstants";

const FinalizeEmptyAFrameMixedModal = ({ open, header, className }: any) => {
  useEffect(() => {
    function onOpen() {
      SharedFunctions.LogPopupShownEvent(`${FINALIZE_EMPTY_AFRAMEMIXED_MODAL} pga: ${header}`);
    }
    if (open) {
      onOpen();
    }
  }, [open, header]);

  return (
    <Modal
      open={open}
      size="small"
      className={className}
      closeOnEscape={false}
      closeOnDimmerClick={false}
    >
      <Header>{header}</Header>
      <Modal.Content>
        <div>
          <Icon className="flipped" name="hand point down outline" />
          <span className="pushDaButtons">TRYCK PÅ KNAPPARNA</span>
          <Icon className="righthand" name="hand point down outline" />
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default WithEventWarning(FinalizeEmptyAFrameMixedModal);
